export default [
  '#ef5350',
  '#f44336',
  '#e53935',
  '#d32f2f',
  '#c62828',
  '#b71c1c',
  '#ff5252',
  '#ff1744',
  '#d50000',
  '#f06292',
  '#ec407a',
  '#e91e63',
  '#d81b60',
  '#c2185b',
  '#ad1457',
  '#880e4f',
  '#ff4081',
  '#f50057',
  '#c51162',
  '#ba68c8',
  '#ab47bc',
  '#9c27b0',
  '#8e24aa',
  '#7b1fa2',
  '#6a1b9a',
  '#4a148c',
  '#e040fb',
  '#d500f9',
  '#aa00ff',
  '#9575cd',
  '#7e57c2',
  '#673ab7',
  '#5e35b1',
  '#512da8',
  '#4527a0',
  '#311b92',
  '#7c4dff',
  '#651fff',
  '#6200ea',
  '#7986cb',
  '#5c6bc0',
  '#3f51b5',
  '#3949ab',
  '#303f9f',
  '#283593',
  '#1a237e',
  '#536dfe',
  '#3d5afe',
  '#304ffe',
  '#2196f3',
  '#1e88e5',
  '#1976d2',
  '#1565c0',
  '#0d47a1',
  '#2962ff',
  '#039be5',
  '#0288d1',
  '#0277bd',
  '#01579b',
  '#0091ea',
  '#0097a7',
  '#00838f',
  '#006064',
  '#009688',
  '#00897b',
  '#00796b',
  '#00695c',
  '#004d40',
  '#43a047',
  '#388e3c',
  '#2e7d32',
  '#1b5e20',
  '#689f38',
  '#558b2f',
  '#33691e',
  '#827717',
  '#ef6c00',
  '#e65100',
  '#ff5722',
  '#f4511e',
  '#e64a19',
  '#d84315',
  '#bf360c',
  '#ff3d00',
  '#dd2c00',
  '#a1887f',
  '#8d6e63',
  '#795548',
  '#6d4c41',
  '#5d4037',
  '#4e342e',
  '#3e2723',
  '#78909c',
  '#607d8b',
  '#546e7a',
  '#455a64',
  '#37474f',
  '#263238',
  '#757575',
  '#616161',
  '#424242',
  '#212121',
]
